// The app is not a PWA: it never registers a service worker. `unregister()` is
// still called on start-up so that any worker registered by an older build of
// the app is torn down instead of serving stale, cached assets.

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
